import "./iconGrid.scss";
import IconGridItem, {
  iconGridItemData,
} from "components/iconGrid/iconGridItem";
import ButtonSolid, {
  ButtonSolidType,
} from "components/buttonSolid/buttonSolid";
import { useLayoutEffect, useRef, useState } from "react";

interface iconGridProps {
  button: ButtonSolidType;
  title: string;
  copy: string;
  items: iconGridItemData[];
  header: string;
}

const IconGrid: React.FC<iconGridProps> = (props) => {
  const [isIn, setIsIn] = useState<boolean>(false);
  const gridRef = useRef<HTMLDivElement>(null!);

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (gridRef.current) {
        const box = gridRef.current.getBoundingClientRect();
        if (box.top < window.innerHeight) {
          setIsIn(true);
        }
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, [isIn]);

  return (
    <div className="icon-grid">
      <div className="icon-grid__header">{props.header}</div>
      <div className="icon-grid__grid" ref={gridRef}>
        <div className="icon-grid__grid-row grid-row">
          {props.items.map((item: iconGridItemData, key: number) => (
            <IconGridItem
              {...item}
              active={isIn}
              index={key}
              key={key}
              delay={`${1 + (1.5 / props.items.length) * key}s`}
            />
          ))}
        </div>
      </div>

      <ButtonSolid {...props.button} />
    </div>
  );
};

export default IconGrid;
